import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    agreementAnalysisResult: [],
    overallAnalysisResult: [],
    secondaryAnalysisResult: [],
    fragranceAssociationResult: [],

    defaultAgreementAnalysisResult: [],
    defaultOverallAnalysisResult: [],
    defaultSecondaryAnalysisResult: [],
    defaultFragranceAssociationResult: [],

    claimsAnalysisResult: [],
    defaultClaimsAnalysisResult: [],

    justRightAnalysisResult: [],
    defaultJustRightAnalysisResult: [],

    fragranceMetricsAnalysisResult: [],
    defaultFragranceMetricsAnalysisResult: [],

    preferenceAnalysisResult: [],
    defaultPreferenceAnalysisResult: [],

    productPreferenceAnalysisResult: [],
    defaultProductPreferenceAnalysisResult: [],

    likertScaleData: {},

    isAgreementAnalysisResultLoading: true,
    isOverallAnalysisResultLoading: true,
    isSecondaryAnalysisResultLoading: true,

    isClaimsAnalysisResultLoading: true,
    isJustRightAnalysisResultLoading: true,

    isFragranceMetricsAnalysisResultLoading: true,
    isPreferenceAnalysisResultLoading: true,
    isProductPreferenceAnalysisResultLoading: true,

    weightToggle: false,
    overallToggle: false,
    penaltyToggle: false,
    disableWeightToggle: true,
    isItmData: false,
    isItmDataShown: false,
    percentageToggle: false,
    overallFragranceToggle: true,
    overallAbsoluteToggle: false,
    secondaryAbsoluteToggle: false,
    agreementAbsoluteToggle: false,
    claimsAbsoluteToggle: false,

    significanceToggle: false,
    disableSignificanceToggle: true,

    top2BoxAggToggle: { value: "top_2_box", label: "Top 2-Box %" },
    top2BoxClaimsToggle: { value: "top_2_box", label: "Top 2-Box %" },
    dataView: { value: "mean", label: "Mean" },
    selectedDataset: { value: "recall", label: "Recall Data" },

    // Overall
    scoreDistributionSelectedVariableOverall: "",
    scoreDistributionGroupsOverall: [],
    isScoreDistributionShownOverall: true,

    // Additional
    scoreDistributionSelectedVariableAdditional: "",
    scoreDistributionGroupsAdditional: [],
    isScoreDistributionShownAdditional: true,

    // chart Scale reset State
    chartScaleReset: true,

    productColors: [],
    analysisSwitchState: {},
    selectedMicroCategory: "",

    fragranceAssociationOpenParentList: [],
    activeTab: "",
};

export const analysisResultsStore = createSlice({
    name: "analysisResultsStore",
    initialState,
    reducers: {
        loadAgreementAnalysisResultState: (state, action) => {
            state.agreementAnalysisResult = action.payload;
        },
        loadFragranceAssociationResultState: (state, action) => {
            state.fragranceAssociationResult = action.payload;
        },
        loadOverallAnalysisResultState: (state, action) => {
            state.overallAnalysisResult = action.payload;
        },
        loadSecondaryAnalysisResultState: (state, action) => {
            state.secondaryAnalysisResult = action.payload;
        },
        loadLikertScaleDataState: (state, action) => {
            state.likertScaleData = action.payload;
        },
        loadClaimsAnalysisResultState: (state, action) => {
            state.claimsAnalysisResult = action.payload;
        },
        loadJustRightAnalysisResultState: (state, action) => {
            state.justRightAnalysisResult = action.payload;
        },
        loadFragranceMetricsAnalysisResultState: (state, action) => {
            state.fragranceMetricsAnalysisResult = action.payload;
        },
        loadPreferenceAnalysisResultState: (state, action) => {
            state.preferenceAnalysisResult = action.payload;
        },
        loadProductPreferenceAnalysisResultState: (state, action) => {
            state.productPreferenceAnalysisResult = action.payload;
        },

        loadDefaultAgreementAnalysisResultState: (state, action) => {
            state.defaultAgreementAnalysisResult = action.payload;
        },
        loadDefaultOverallAnalysisResultState: (state, action) => {
            state.defaultOverallAnalysisResult = action.payload;
        },
        loadDefaultSecondaryAnalysisResultState: (state, action) => {
            state.defaultSecondaryAnalysisResult = action.payload;
        },

        loadDefaultClaimsAnalysisResultState: (state, action) => {
            state.defaultClaimsAnalysisResult = action.payload;
        },
        loadDefaultJustRightAnalysisResultState: (state, action) => {
            state.defaultJustRightAnalysisResult = action.payload;
        },
        loadDefaultFragranceMetricsAnalysisResultState: (state, action) => {
            state.defaultFragranceMetricsAnalysisResult = action.payload;
        },
        loadDefaultPreferenceAnalysisResultState: (state, action) => {
            state.defaultPreferenceAnalysisResult = action.payload;
        },
        loadDefaultProductPreferenceAnalysisResultState: (state, action) => {
            state.defaultProductPreferenceAnalysisResult = action.payload;
        },
        loadDefaultFragranceAssociationResultState: (state, action) => {
            state.defaultFragranceAssociationResult = action.payload;
        },
        loadIsAgreementAnalysisResultLoadingState: (state, action) => {
            state.isAgreementAnalysisResultLoading = action.payload;
        },
        loadIsOverallAnalysisResultLoadingState: (state, action) => {
            state.isOverallAnalysisResultLoading = action.payload;
        },
        loadIsSecondaryAnalysisResultLoadingState: (state, action) => {
            state.isSecondaryAnalysisResultLoading = action.payload;
        },
        loadIsClaimsAnalysisResultLoadingState: (state, action) => {
            state.isClaimsAnalysisResultLoading = action.payload;
        },
        loadIsJustRightAnalysisResultLoadingState: (state, action) => {
            state.isJustRightAnalysisResultLoading = action.payload;
        },
        loadIsFragranceMetricsAnalysisResultLoadingState: (state, action) => {
            state.isFragranceMetricsAnalysisResultLoading = action.payload;
        },
        loadIsPreferenceAnalysisResultLoadingState: (state, action) => {
            state.isPreferenceAnalysisResultLoading = action.payload;
        },
        loadIsProductPreferenceAnalysisResultLoadingState: (state, action) => {
            state.isProductPreferenceAnalysisResultLoading = action.payload;
        },
        loadWeightToggleState: (state, action) => {
            state.weightToggle = action.payload;
        },
        loadPenaltyToggleState: (state, action) => {
            state.penaltyToggle = action.payload;
        },
        loadOverallToggleState: (state, action) => {
            state.overallToggle = action.payload;
        },
        loadDisableWeightToggleState: (state, action) => {
            state.disableWeightToggle = action.payload;
        },
        loadIsItmDataState: (state, action) => {
            state.isItmData = action.payload;
        },
        loadSelectedDatasetState: (state, action) => {
            state.selectedDataset = action.payload;
        },
        loadIsItmDataShownState: (state, action) => {
            state.isItmDataShown = action.payload;
        },
        loadPercentageToggleState: (state, action) => {
            state.percentageToggle = action.payload;
        },
        loadOverallAbsoluteToggleState: (state, action) => {
            state.overallAbsoluteToggle = action.payload;
        },
        loadSecondaryAbsoluteToggleState: (state, action) => {
            state.secondaryAbsoluteToggle = action.payload;
        },
        loadAgreementAbsoluteToggleState: (state, action) => {
            state.agreementAbsoluteToggle = action.payload;
        },
        loadClaimsAbsoluteToggleState: (state, action) => {
            state.claimsAbsoluteToggle = action.payload;
        },
        loadOverallFragranceToggleState: (state, action) => {
            state.overallFragranceToggle = action.payload;
        },
        loadSignificanceToggleState: (state, action) => {
            state.significanceToggle = action.payload;
        },
        loadDisableSignificanceToggleState: (state, action) => {
            state.disableSignificanceToggle = action.payload;
        },
        loadTop2BoxAggToggleState: (state, action) => {
            state.top2BoxAggToggle = action.payload;
        },
        loadTop2BoxClaimsToggleState: (state, action) => {
            state.top2BoxClaimsToggle = action.payload;
        },
        loadDataViewState: (state, action) => {
            state.dataView = action.payload;
        },
        loadScoreDistributionSelectedVariableOverallState: (state, action) => {
            state.scoreDistributionSelectedVariableOverall = action.payload;
        },
        loadScoreDistributionGroupsOverallState: (state, action) => {
            state.scoreDistributionGroupsOverall = action.payload;
        },
        loadIsScoreDistributionShownOverallState: (state, action) => {
            state.isScoreDistributionShownOverall = action.payload;
        },
        loadScoreDistributionSelectedVariableAdditionalState: (state, action) => {
            state.scoreDistributionSelectedVariableAdditional = action.payload;
        },
        loadScoreDistributionGroupsAdditionalState: (state, action) => {
            state.scoreDistributionGroupsAdditional = action.payload;
        },
        loadIsScoreDistributionShownAdditionalState: (state, action) => {
            state.isScoreDistributionShownAdditional = action.payload;
        },
        loadChartScaleResetState: (state, action) => {
            state.chartScaleReset = action.payload;
        },
        loadProductColorsState: (state, action) => {
            state.productColors = action.payload;
        },
        loadSelectedMicroCategoryState: (state, action) => {
            state.selectedMicroCategory = action.payload;
        },
        loadAnalysisSwitchState: (state, action) => {
            state.analysisSwitchState = action.payload;
        },
        loadFragranceAssociationOpenParentListState: (state, action) => {
            state.fragranceAssociationOpenParentList = action.payload;
        },
        loadActiveTabState: (state, action) => {
            state.activeTab = action.payload;
        },
        // Add the reset action here
        resetAnalysisResultsStoreState: () => initialState,
    },
});

export const {
    loadAgreementAnalysisResultState,
    loadOverallAnalysisResultState,
    loadSecondaryAnalysisResultState,
    loadClaimsAnalysisResultState,
    loadJustRightAnalysisResultState,
    loadFragranceMetricsAnalysisResultState,
    loadPreferenceAnalysisResultState,
    loadFragranceAssociationResultState,
    loadProductPreferenceAnalysisResultState,

    loadDefaultAgreementAnalysisResultState,
    loadDefaultOverallAnalysisResultState,
    loadDefaultSecondaryAnalysisResultState,
    loadDefaultClaimsAnalysisResultState,
    loadDefaultJustRightAnalysisResultState,
    loadDefaultFragranceMetricsAnalysisResultState,
    loadDefaultPreferenceAnalysisResultState,
    loadDefaultProductPreferenceAnalysisResultState,
    loadDefaultFragranceAssociationResultState,

    loadLikertScaleDataState,

    loadIsAgreementAnalysisResultLoadingState,
    loadIsOverallAnalysisResultLoadingState,
    loadIsSecondaryAnalysisResultLoadingState,
    loadIsClaimsAnalysisResultLoadingState,
    loadIsJustRightAnalysisResultLoadingState,
    loadIsFragranceMetricsAnalysisResultLoadingState,
    loadIsPreferenceAnalysisResultLoadingState,
    loadIsProductPreferenceAnalysisResultLoadingState,

    loadPenaltyToggleState,
    loadWeightToggleState,
    loadOverallToggleState,
    resetAnalysisResultsStoreState,
    loadDisableWeightToggleState,
    loadIsItmDataState,
    loadSelectedDatasetState,
    loadIsItmDataShownState,
    loadPercentageToggleState,
    loadOverallFragranceToggleState,

    loadOverallAbsoluteToggleState,
    loadSecondaryAbsoluteToggleState,
    loadAgreementAbsoluteToggleState,
    loadClaimsAbsoluteToggleState,

    loadSignificanceToggleState,
    loadDisableSignificanceToggleState,

    loadTop2BoxAggToggleState,
    loadTop2BoxClaimsToggleState,
    loadDataViewState,

    loadScoreDistributionSelectedVariableOverallState,
    loadScoreDistributionGroupsOverallState,
    loadIsScoreDistributionShownOverallState,

    loadScoreDistributionSelectedVariableAdditionalState,
    loadScoreDistributionGroupsAdditionalState,
    loadIsScoreDistributionShownAdditionalState,

    loadChartScaleResetState,

    loadProductColorsState,
    loadSelectedMicroCategoryState,
    loadAnalysisSwitchState,

    loadFragranceAssociationOpenParentListState,
    loadActiveTabState,
} = analysisResultsStore.actions;

export default analysisResultsStore.reducer;
